<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>

<section>
    <div class="main-div">
        <div class="images-div">
            <div class="mobile-div">
                <img
                    src="images/Perfomance/Vectarytexture.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="back-div">
                <img
                    src="images/Perfomance/back1.svg"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="Number">
                <p>1</p>
            </div>
            <div class="text-div">
                <p>Performers & Opus</p>
                <p>ACTORS & MODELS</p>
                <p>
                    As an actor or model, your likeness is your brand, your
                    product and your intellectual property. Traditionally
                    however, the path to achieve fame and to truly reap the
                    reward of the talent is a never ending, tedious and most of
                    the time an unrewarding grind.
                </p>
                <p>
                    Using <span style="color: #1C7BFF;"
                        >our performance capture app,</span
                    > you can immortalize your likeness as it is today and retain
                    it digitally forever. The likeness can be endlessly used by a
                    producer and you make money whenever it does.
                </p>
                <p>
                    Also, as an early believer, you will be given a limited time
                    pass to the Governance Council. Take part in making history,
                    vote on important issues and get rewarded for it.
                </p>

                <div class="btn-div">
                    <div>
                        <DesktopButton2
                            state = "Performer"
                            width="24.074vh"
                            text1 = "Join Artist Governance Council"
                            text2="(Actor Seat)"
                            AnimationColor="black"
                            TextColorAfter="#67eebb"
                            BorderColorAfter="black"
                            text3="15"
                        />
                    </div>
                    <div>
                        <DesktopButton2
                            state = "Performer"
                            width="24.074vh"
                            text1 = "Join Artist Governance Council"
                            text2="(Model Seat)"
                            AnimationColor="black"
                            TextColorAfter="#67eebb"
                            BorderColorAfter="black"
                            text3="15"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="scroll_div">
            
            <p class="scrollText" >scroll / drag</p>
            <svg
            width="6.185vh"
            height="0.741vh"
            viewBox="0 0 72 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="img"
        >
            <path
                d="M71.3536 4.35355C71.5488 4.15829 71.5488 3.84171 71.3536 3.64645L68.1716 0.464466C67.9763 0.269204 67.6597 0.269204 67.4645 0.464466C67.2692 0.659728 67.2692 0.976311 67.4645 1.17157L70.2929 4L67.4645 6.82843C67.2692 7.02369 67.2692 7.34027 67.4645 7.53553C67.6597 7.7308 67.9763 7.7308 68.1716 7.53553L71.3536 4.35355ZM0 4.5H71V3.5H0V4.5Z"
            />
        </svg>
        </div>
    </div>
</section>

<style>
    .btn-div {
        display: flex;
        width: 51.389vh;
        justify-content: space-between;
        align-items: center;
        margin-top: 4.074vh;
    }
    .main-div {
        width: 136.481vh;
        height: 100vh;
        position: relative;
    }
    .images-div {
        display: flex;
        position: relative;
    }
    .back-div {
        position: absolute;
        right: 0vh;
        width: 89.722vh;
        height: 100vh;
        pointer-events:none ;
        z-index: -1;
    }
    .mobile-div {
        left: 0vh;
        position: absolute;
        width: 117.037vh;
        height: 100vh;
        pointer-events:none ;
    }
    .text-div {
        position: absolute;
        right: 13.148vh;
        width: 57.685vh;
        font-family: "Orbitron";
        top: 14.722vh;
    }
    .text-div p:nth-child(1) {
        font-size: 1.296vh;
        letter-spacing: 0.058vh;
        font-weight: 400;
        text-transform: uppercase;
    }
    .text-div p:nth-child(2) {
        font-size: 5.556vh;
        line-height: 5.556vh;
        margin-top: 2.407vh;
        margin-bottom: 5.741vh;
        letter-spacing: 0.058vh;
        font-weight: 700;
        text-transform: uppercase;
    }
    .text-div p:nth-child(3) {
        font-size: 1.852vh;
        line-height: 2.593vh;
        letter-spacing: 0.058vh;
        font-weight: 400;
    }
    .text-div p:nth-child(4) {
        font-size: 1.852vh;
        line-height: 2.593vh;
        letter-spacing: 0.058vh;
        font-weight: 600;
    }
    .text-div p:nth-child(5) {
        font-size: 1.852vh;
        line-height: 2.593vh;
        font-weight: 400;
        letter-spacing: 0.058vh;
    }
    .Number{
        position: absolute;
        right: 11.5vh;
        top: -6.229vh;
    }
    .Number p{
        margin: 0;
        font-weight: 700;
        font-size: 27.778vh;
        line-height: 27.778vh;
        color: rgba(255, 255, 255, 0.6);
        font-family: 'Orbitron';
    }
    .scroll_div {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 2.5vh;
        right: -9vh;
    }
    .scroll_div .scrollText {
        font-size: 1.481vh;
        font-weight: 500;
        line-height: 1.857vh;
        font-family: "Orbitron";
        color: black;
        text-transform: capitalize;
    }
    .scroll_div .img {
        margin-left: 1.778vh;
        width: 6.185vh;
        height: 0.741vh;
        fill: black;
}
</style>
